module.exports = __webpack_public_path__ + "img/question-circle-solid.2e5adfe7.svg";